<section class="section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4 d-none d-lg-block">
                <img src="assets/img/about.jpg" alt="service">
            </div>
            <div class="col-lg-8">
                <div class="mr-lg-30">
                    <div class="section-title text-left">
                        <p class="subtitle">01 --- About Us</p>
                        <h4 class="title">Find your next short break</h4>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-lg-30">
                            <p>
                                Camping is an outdoor activity involving overnight stays away from home with or without a shelter, such as a tent or a recreational vehicle Typically participants leave developed areas to spend time outdoors in more natural ones in pursuit of activities.
                            </p>
                            <p>
                                Providing them enjoyment The night or more spent outdoors distinguishes camping.
                            </p>
                            <a routerLink="/about" class="sigma_btn-custom">Learn More</a>
                        </div>
                        <div class="col-lg-6">
                            <div class="sigma_box sigma_box-lg m-0 sigma_box-progress">
                                <div class="d-flex align-items-center mb-4">
                                    <div class="sigma_round-button sm">
                                        <span> <b class="counter" [countUp]="75">0</b> <span class="custom-primary">%</span> </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 197 197" enable-background="new 0 0 197 197" xml:space="preserve">
                                            <circle class="sigma_round-button-stroke" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>
                                            <circle class="sigma_progress-round sigma_round-button-circle" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5" [style.stroke-dashoffset.px]="290"></circle>
                                        </svg>
                                    </div>
                                    <h6 class="mb-0 ml-3">Camping</h6>
                                </div>
                                <p>Camping day-tripping, picnicking, and other similarly short-term recreational activities.</p>
                                <a routerLink="/contact" class="btn-link">Get a Quote</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>